import createCache from "@emotion/cache";

const nonce = window.__CSP_NONCE__ || "NkFmRmJqTnZzM3hpMGZ0dQ==";

export default createCache({
    key: "mui",
    prepend: true,
    nonce
});